<template>
    <div>
        <template v-if="dataType == 1">
            <asset-log-detail></asset-log-detail>
        </template>
        <template v-else>
            <report-log-detail></report-log-detail>
        </template>
    </div>
</template>
<script>
    import assetLogDetail from '@/views/logs/sync/assets/detail'
    import reportLogDetail from '@/views/logs/sync/reports/detail'

    export default {
        name: 'DetailData',
        components: {
            assetLogDetail,
            reportLogDetail
        },
        data() {
            return {
                dataType: this.$route.query.type
            }
        },
        computed: {

        },
        created() {
        },
        methods: {
        },
        watch: {

        }
    }
</script>
<style scoped>
</style>
